// Shared Acquigine logo. Reads brand from /api/admin/brand for white-label tenants.
// The PNG already contains the wordmark, so we never render separate brand-name text.
import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_LOGO = "/images/acquigine-logo.png";

export function LogoMark({ className = "h-10" }) {
  const [brand, setBrand] = useState({ brand_name: "Acquigine", logo_url: DEFAULT_LOGO });
  useEffect(() => {
    api.get("/admin/brand").then((r) => setBrand((b) => ({ ...b, ...r.data }))).catch(() => {});
  }, []);
  return (
    <LogoView
      className={className}
      src={brand.logo_url || DEFAULT_LOGO}
      name={brand.brand_name || "Acquigine"}
    />
  );
}

export function LogoMarkStatic({ src = DEFAULT_LOGO, className = "h-10", name = "Acquigine" }) {
  return <LogoView className={className} src={src} name={name} />;
}

function LogoView({ src, name, className }) {
  const [failed, setFailed] = useState(false);
  const finalSrc = failed && src !== DEFAULT_LOGO ? DEFAULT_LOGO : src;
  return (
    <img
      src={finalSrc}
      alt={name}
      onError={() => setFailed(true)}
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
      data-testid="acquigine-logo"
    />
  );
}
